import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import React, { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider, useStore, useSelector } from 'react-redux';

import RobotMarker from '@/components/ui/map/RobotMarker';
import OlMap from '@/helpers/OlMap';

const Robot = ({ data: robot }) => {
  const store = useStore();
  const globalPosition = useSelector((state) => state.telemetry[robot.id].globalPosition);
  const element = useRef();

  useMountEffect(() => {
    element.current = getMarkerElement();

    return () => {
      OlMap.removeRobot(robot.id);
    };
  });

  useUpdateEffect(() => {
    const { lat, lng, hdg } = globalPosition;

    element.current.style.transform = `rotate(${hdg}deg)`;
    OlMap.addRobot(robot.id, element.current, { lat, lng });
  }, [globalPosition]);

  const getMarkerElement = () => {
    const content = document.createElement('div');

    createRoot(content).render(
      <Provider store={store}>
        <RobotMarker data={robot} />
      </Provider>
    );
    return content;
  };
};

const GuideRobots = () => {
  const robots = useSelector((state) => state.robots);

  return (
    <>
      {robots
        .filter(({ isShow }) => isShow)
        .map((robot) => (
          <Robot key={robot.id} data={robot} />
        ))}
    </>
  );
};

export default GuideRobots;
